// React
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
// App files
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import ReactGA from 'react-ga4';
import store from "./reducers/index";

ReactGA.initialize('G-DHQTENL4XQ');

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
